import styled from 'styled-components';
import { COLOR_PALETTE } from '../../common/colors';
import { LAYERS, SIZE } from '../../common/sizes';
import { DEFAULT_FONT_FAMILY } from '../../common/constants';
import { BUTTON_PRIMARY } from 'components/TCButton/styles';

export interface DatePickerProps {
    comparisonStyles?: boolean;
}

export const DatePickerContainer = styled.div`
    padding: ${SIZE.ONE}px;

    *{
        box-sizing: border-box;
        font-family: ${DEFAULT_FONT_FAMILY};
    }

    .DateRangePicker_picker__directionLeft{
        left: -389.25px !important;
        top: 53px !important;
    }

    .DateRangePickerInput{
        display: inline-flex;
        height: ${SIZE.FIVE}px;
        border-radius: 2px;
        background-color: ${COLOR_PALETTE.SNOWFLAKE};
        box-shadow: 0 2px 4px 0 rgba(55, 63, 83, 0.2);
        justify-content: center;
        align-items: center;

        border: solid 2px #122442;
        border-radius: 4px;
        padding: 8px 19px 7px 19px;
    }

    .DateInput_input{
        font-family: Lato;
        font-size: 14px;
        font-weight: bold;
        margin: 0;
        padding: 0;
    }

    .DateRangePickerInput_arrow{
        display: flex;
        margin-right: 6px;
    }

    .CalendarDay__default {
        border: unset;
        width: 28px;
    }

    .CalendarDay__default:hover {
        background-color: ${COLOR_PALETTE.CHASSIS_LIGHT_GRAY_2};
        border-radius: 50%;
    }

    .DateInput_input{
        width: 86px;
        cursor: pointer;
    }

    .DateInput__small{
        width: 86px;
        cursor: pointer;
    }

    .DateRangePickerInput_calendarIcon{
        margin: 0;
        margin-right: 8px;
        padding:0;
        z-index: ${LAYERS.LAYER_1};
        display: flex;
        padding: 0;
    }

    .DateInput_input__focused::placeholder{
        color: ${COLOR_PALETTE.SNOWFLAKE}
    }

    .CalendarMonth_caption {
        font-family: Rubik;
        font-size: 12px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #112240;
        >strong {
            padding: 5px 20px;
            border-radius: 3px;
            border: solid 1px #dadce1;
        }
    }

    .DayPickerNavigation_button__default{
        border: unset;
    }
    
    .CalendarDay__blocked_calendar{
        background-color: transparent !important;
    }

    ${(props: DatePickerProps) =>
        props.comparisonStyles ?
            // comparison styles
            `
        

        .CalendarDay__highlighted_calendar,
        .CalendarDay__highlighted_calendar:hover{
            background-color: ${COLOR_PALETTE.CHASSIS_LIGHT_BLUE_GRAY};
            color: ${COLOR_PALETTE.SNOWFLAKE};
        }

        .CalendarDay__selected, 
        .CalendarDay__selected:active, 
        .CalendarDay__selected:hover{
            background-color: #2b3a66cf;
            border: unset;
        }

        .CalendarDay__selected_span:active, 
        .CalendarDay__selected_span:hover{
            background-color: #2b3a66cf;
        }
        
        .CalendarDay__hovered_span, 
        .CalendarDay__hovered_span:hover{
            background-color: red;
            color: ${COLOR_PALETTE.SNOWFLAKE}
        }

        .CalendarDay__selected_span{
            background-color: ${COLOR_PALETTE.PETER_PAN};
            color: ${COLOR_PALETTE.SNOWFLAKE}
        }

        .CalendarDay__selected_end, 
        .CalendarDay__selected_start{
            background-color: #2b3a66;
            color: ${COLOR_PALETTE.SNOWFLAKE}
        }

        .DateInput_input__focused {
            background-color: ${COLOR_PALETTE.PETER_PAN};
            width: ${SIZE.TEN}px;
            height: ${SIZE.THREE}px;
            border-radius: 2px;
            color: ${COLOR_PALETTE.SNOWFLAKE};
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: normal;
            letter-spacing: 1.1px;
            display: flex;
        }        
        `
            :
            // regular styles
            `

        .CalendarDay__highlighted_calendar,
        .CalendarDay__highlighted_calendar:hover {
            background-color: ${COLOR_PALETTE.PETER_PAN};
            color: ${COLOR_PALETTE.SNOWFLAKE};
        }

        .CalendarDay__selected, 
        .CalendarDay__selected:active, 
        .CalendarDay__selected:hover{
            background-color: ${COLOR_PALETTE.BLUE_DARK_1};
            color: ${COLOR_PALETTE.SNOWFLAKE};
            border: unset;
        }

        .CalendarDay__selected_span:active,
        .CalendarDay__selected_span:hover{
            background-color: #2b3a66ad;
            color: ${COLOR_PALETTE.SNOWFLAKE};
        }

        .CalendarDay__hovered_span, 
        .CalendarDay__hovered_span:hover{
            background-color: #2b3a66c4;
            color: ${COLOR_PALETTE.SNOWFLAKE};
            border-radius: 50%;
        }



        .CalendarDay__selected_span{
            background-color: #f2f5fa;;
            color: #112240;
            border: unset;
        }

        .CalendarDay__selected_end, .CalendarDay__selected_start{
            border-radius: 50%;
            background-color: #2b3a66;
            color: ${COLOR_PALETTE.SNOWFLAKE};
        }



        .DateInput_input__focused {
            width: 86px;
            height: ${SIZE.THREE}px;
            border-radius: 2px;
            font-style: normal;
            font-stretch: normal;
            line-height: normal;
            letter-spacing: 1.1px;
            display: flex;
        }
        `
    }
`;

export const DateLabel = styled.div`
    padding-left: ${SIZE.ONE}px;
    height: ${SIZE.TWO}px;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 1.1px;
    color: ${COLOR_PALETTE.CHASSIS_GRAY};
`;

export const PresetContainer = styled.div`
    padding: 0px 23px;
`;

export const PresetBtn = styled.button`
    height: ${SIZE.FOUR}px;
    border-radius: 2px;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 1.1px;
    text-align: center;
    background-color: ${COLOR_PALETTE.SNOWFLAKE};
    margin: 0 ${SIZE.ONE}px ${SIZE.ONE}px ${SIZE.ONE}px;
    color: ${COLOR_PALETTE.STEAK_CHAR};
    &:active{
        background-color: ${COLOR_PALETTE.CHASSIS_GRAY};
        border: solid 1px ${COLOR_PALETTE.CHASSIS_GRAY};
        color: ${COLOR_PALETTE.SNOWFLAKE}
    }
`;

export const DatePickerSingleContainer = styled.div`
    *{
        box-sizing: border-box;
        font-family: ${DEFAULT_FONT_FAMILY};
    }

    .SingleDatePickerInput {
        background: transparent;
    }

    .DateRangePickerInput{
        /*FLEX.FILL*/
        height: ${SIZE.FIVE}px;
        justify-content: flex-start;
        align-items: center;
    }

    .DateInput {
        background-color: transparent;
        width:${SIZE.TWENTYEIGHT}px;
    }

    .DateInput_input{
        font-size: 16px;
        font-family: ${DEFAULT_FONT_FAMILY};
        margin: 0;
        padding: 0;
        height: 36px;
        background: transparent;
    }

    .DateRangePickerInput_arrow{
        display: flex;
        margin-right: 6px;
    }

    .CalendarDay__default:hover {
        background-color: ${COLOR_PALETTE.CHASSIS_GRAY};
    }

    .DateInput_input{
        cursor: pointer;
        width: ${SIZE.TWENTYEIGHT}px;
        height: ${SIZE.FIVE}px;
        border-radius: 2px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1.1px;
        display: flex;
        padding: 0px;
        background: transparent;
    }

    .DateInput__small:nth-child(3){
        width: 86px;
        cursor: pointer;
    }

    .DateRangePickerInput_calendarIcon{
        margin: 0;
        margin-right: -18px;
        padding:0;
        z-index: ${LAYERS.LAYER_1};
        display: flex;
        padding: 0;
    }

    .DateInput_input::placeholder,
    .DateInput_input__focused::placeholder{
        font-family: ${DEFAULT_FONT_FAMILY};
        font-size: 14px;
        color: #b1b2b5;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        letter-spacing: 1.5px;
    }

    .CalendarDay__highlighted_calendar,
    .CalendarDay__highlighted_calendar:hover {
        background-color: ${COLOR_PALETTE.PETER_PAN};
        color: ${COLOR_PALETTE.SNOWFLAKE};
    }

    .CalendarDay__selected, 
    .CalendarDay__selected:active, 
    .CalendarDay__selected:hover{
        background-color: ${COLOR_PALETTE.BLUE_DARK_1};
        color: ${COLOR_PALETTE.SNOWFLAKE};
    }

    .CalendarDay__selected_span:active,
    .CalendarDay__selected_span:hover{
        background-color: ${COLOR_PALETTE.BLUE_DARK_1};
        color: ${COLOR_PALETTE.SNOWFLAKE};
    }

    .CalendarDay__hovered_span, 
    .CalendarDay__hovered_span:hover{
        background-color: ${COLOR_PALETTE.BLUE_DARK_1};
        color: ${COLOR_PALETTE.SNOWFLAKE};
    }

    .CalendarDay__selected_span{
        background-color: ${COLOR_PALETTE.CHASSIS_LIGHT_BLUE_GRAY};
        color: ${COLOR_PALETTE.SNOWFLAKE}
    }

    .CalendarDay__selected_end, .CalendarDay__selected_start{
        background-color: ${COLOR_PALETTE.BLUE_DARK_1};
        color: ${COLOR_PALETTE.SNOWFLAKE};
    }

    .DateInput_input__focused {
        width: ${SIZE.TWENTYEIGHT}px;
        height: ${SIZE.FIVE}px;
        border-radius: 2px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1.1px;
        display: flex;
        padding: 0px;
        background: transparent;
    }

`

export const ButtonContainer = styled.div`
    height: 64px;    
    ${BUTTON_PRIMARY}{
        width: 112px;    
        height: 44px; 
        margin-left: auto; 
    }
`;